import React from 'react';

class SocietyInfo extends React.Component {


  render (){
    return (
      <div style={{display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center'}}>
        <p style={{fontSize: '1em', fontWeight: 'bold', color: 'grey'}}>{this.props.Name ? this.props.Name : ""}</p>
      </div>
    )
  }
}

export default SocietyInfo;
